import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { useHistory } from 'react-router-dom'

import Error from '@Components/VAC/exception'
import useBoardRegister from '@Hooks/myhouse/board/useBoardRegister'
import { FETCH_STATUS } from '@Root/contants'
import { getDeniedPath, LAND_DENIED_TYPE } from '@Root/contants/myhouseError'

function PenaltyPage() {
  const history = useHistory()
  const { loadPenalty, reduxBoardRegister } = useBoardRegister()
  const { penalty } = reduxBoardRegister
  const [props, setProps] = useState({})
  useEffect(() => {
    loadPenalty()
  }, [])

  useEffect(() => {
    if (penalty.fetchStatus === FETCH_STATUS.SUCCESS) {
      if (!penalty.code) {
        // 제재 없이 접근한 경우
        history.replace(getDeniedPath(LAND_DENIED_TYPE.NOT_PENALTY))
      } else if (penalty.code === 'AA17') {
        // 영구 제재
        setProps({
          error: {
            title: '글쓰기 영구 제한 상태입니다.',
            description: '우리집 서비스에서 더 이상\n게시글을 작성하실 수 없습니다.',
            button: '우리집 바로가기',
            handleClick: () => {
              window.location.href = '/myhouse'
            },
          },
        })
      } else {
        // 기타 제재
        const date = dayjs(penalty.toDate).format('YYYY.MM.DD')
        setProps({
          error: {
            title: '글쓰기 제한 상태입니다.',
            description: '글쓰기 제한 기간 동안 우리집 서비스에서\n게시글을 작성하실 수 없습니다.',
            button: '우리집 바로가기',
            handleClick: () => {
              window.location.href = '/myhouse'
            },
          },
          maintenance: {
            description: `(제한 종료일 : ${date}.)`,
          },
        })
      }
    }
  }, [penalty.fetchStatus])

  return (
    <>
      <Error {...props} />
    </>
  )
}
export default PenaltyPage
